import { ParentType } from '@olagg/api-hooks';
import { RankingFilter } from '.';
import { MdTour } from 'react-icons/md';
import { GiFlagObjective } from 'react-icons/gi';
import { RiGlobalLine } from 'react-icons/ri';

export const commonTypeFilters: Array<RankingFilter> = [
    {
      label: 'general',
      labelMobile: <RiGlobalLine />,
      parentId: null,
      parentType: null,
    },
    {
      label: 'tournaments',
      labelMobile: <MdTour />,
      parentId: null,
      parentType: ParentType.TOURNAMENT,
    },
    {
      label: 'quests',
      labelMobile: <GiFlagObjective />,
      parentId: null,
      parentType: ParentType.QUEST,
    },
    {
      label: 'content',
      labelMobile: 'C.',
      parentId: null,
      parentType: ParentType.USER_CONTENT,
    },
  ];
  
export const commonTimeFilters: Array<RankingFilter> = [
  {
    label: 'season',
    from: '2024-02-07T04:00:00.000Z',
    to: '2024-03-26T00:00:00.000Z',
  },
  {
    label: 'fromSep2023',
    from: '2023-09-01T00:00:00.000Z',
    to: null,
  },
  {
    label: '7days',
    from: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    to: null,
  },
  {
    label: '30days',
    from: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    to: null,
  }
];
  